import type { ReactNode } from 'react';

/**
 * Who decides what is in this card, beside its heading.
 *
 * Not decoration. Whether an operator may change a number is the first thing
 * they need to know about it, and finding that out by clicking into a form that
 * does not exist is finding it out too late. "Derived, not set" is the one that
 * earns the component on its own: targets look editable and are arithmetic.
 */
export function OwnerBadge({ children }: { readonly children: ReactNode }) {
  return (
    <span className="inline-flex min-h-[19px] shrink-0 items-center rounded-[10px] bg-mute-bg px-[7px] text-xs font-medium whitespace-nowrap text-mute-fg">
      {children}
    </span>
  );
}
